export default __webpack_public_path__ + "static/media/andrea-enriquez-cousino-C1HhAQrbykQ-unsplash.42284222.jpg";